import { FilterDropdown } from "@repo/ui";

import type { DropDownProps } from ".";

interface Props extends DropDownProps<"companyManagementAreaIds"> {}

export function ManagementAreaDropdown(props: Props) {
	return (
		<FilterDropdown
			{...props}
			id="companyManagementAreaIds"
			values={props.options?.data ?? []}
			objectName="Management Area"
			label={props.label ?? "Management Area"}
			fullLength
			isMulti
		/>
	);
}
